import type { FC } from 'react';
import Button from '@components/Button';
import { Show, ShowFirstMatching } from '@components/Show';

import { buttonsContainerClasses } from '../classes';
import { EndorsementStep } from '../types';

interface FormFooterProps {
  currentStep: EndorsementStep;
  isEdit: boolean;
  isLoading: boolean;
  isStandalone: boolean;
  isValid: boolean;
  onNext: () => void;
  onPrevious: () => void;
}

export const FormFooter: FC<FormFooterProps> = ({
  currentStep,
  isEdit,
  isLoading,
  isStandalone,
  isValid,
  onNext,
  onPrevious,
}) => {
  const isFirstStep = isStandalone
    ? currentStep === EndorsementStep.ParentSelection
    : currentStep === EndorsementStep.SummaryTemplate;
  const isLastStep = currentStep === EndorsementStep.ReasonPremium;

  const backButtonLabel = isFirstStep ? 'Cancel' : 'Previous';

  return (
    <div className={buttonsContainerClasses.join(' ')}>
      <Button className="h-9.5" kind="secondary" onClick={onPrevious} isDisabled={isLoading}>
        {backButtonLabel}
      </Button>
      <ShowFirstMatching>
        <Show when={isLastStep}>
          <Button
            className="h-9.5"
            isDisabled={!isValid || isLoading}
            type="submit"
            kind="primary"
            loading={isLoading}
            data-testid="create-button"
          >
            {isEdit ? 'Update' : 'Create'}
          </Button>
        </Show>
        <Show when={!isLastStep}>
          <Button
            className="h-9.5"
            onClick={onNext}
            type="button"
            kind="primary"
            isDisabled={!isValid || isLoading}
            data-testid="next-button"
          >
            Next
          </Button>
        </Show>
      </ShowFirstMatching>
    </div>
  );
};
